import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const project = RepositoryFactory.get("project");
const users = RepositoryFactory.get("users");

export default {
  createProject({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await project.createProject(payload);
        console.log(data, "actions");
        localStorage.setItem("community", data.data.projectName);
        commit("SET_PROJECT", { key: "selectedProject", value: data.data });
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getProject({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await project.getProject(payload);
        localStorage.setItem("community", data.data.projectName);
        commit("SET_PROJECT", { key: "selectedProject", value: data.data });
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateProject({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await project.updateProject(payload);
        console.log(data, "from moduleactions");
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRoles({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await project.getRoles(payload);
        commit("USER_ROLES", { key: "roles", value: data.data });
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllUsers({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await users.getAll(payload);
        commit("SET_USERS", { key: "users", value: data.data.registeredUser });
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addMember({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await users.addMember(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addUserFromWhatsapp({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await users.addUserFromWhatsapp(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  bulkUpload({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await users.bulkUpload(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateBill({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await project.updateBill(payload);
        console.log(data, "from moduleactions");
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getVersion({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await project.getVersion(payload);
        commit("SET_LATEST_VERSIONS", data.data[0]);
        commit("SET_VERSIONS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateTaskList({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await project.updateTaskList(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getTaskList({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await project.getTaskList(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
